import csTools from "cornerstone-tools";
const scroll = csTools.importInternal("util/scroll");
const BaseTool = csTools.importInternal("base/BaseTool");

/**
 * @public
 * @class StackScrollMouseWheelTool
 * @memberof Tools
 *
 * @classdesc Tool for scrolling through a series using the mouse wheel.
 * @extends Tools.Base.BaseTool
 */
export class StackScrollMouseWheelTool extends BaseTool {
  constructor(props = {}) {
    const defaultProps = {
      name: 'StackScrollMouseWheel',
      supportedInteractionTypes: ['MouseWheel'],
      configuration: {
        loop: false,
        allowSkipping: true,
        invert: false,
      },
    };

    super(props, defaultProps);
  }

  activeCallback(element, event) {
    this.configuration.invert = event.invert;
  }

  mouseWheelCallback(evt) {
    const { direction: images, element } = evt.detail;
    const { loop, allowSkipping, invert } = this.configuration;
    const direction = invert ? -images : images;

    scroll(element, direction, loop, allowSkipping);
  }
}